<template>
    <div :data-cy="`HighlightTypeItem-${type_id}-button`"
        :class="
            'd-flex flex-column justify-center align-center pa-3 border-radius-1 h-type transition-all ' +
            (active ? 'active' : '')
        "
        :style="bgcolor && active ? 'background-color:' + bgcolor + '; border-color: ' + bordercolor : 'background-color:' + bgcolor + '; border-color: ' + bgcolor"
        :id="`h-type-${type_id}`"
        @click="setSelectedType"
    >
        <img height="48" :src="img" alt="icono de marcador" />
        <span class="font-size-12">{{ value }}</span>
    </div>
</template>
<script>
export default {
    props: {
        type_id: { type: [Number, String], default: null },
        img: { type: String, default: null },
        value: { type: String, default: null },
        active: { type: Boolean, default: null },
        bgcolor: { type: String, default: null },
        bordercolor: { type: String, default: null },
    },
    methods: {
        setSelectedType() {
            this.$emit('select')
        },
    },
}
</script>
